import { useEffect, useState } from 'react';
import { useCreateTagMutation } from '../../gql/generated';
import { TagKnown } from '../../Pages/ManageTags/TagsTable';
import { FormInput, FormLabelContainer } from '../../StyledComponents/Form';
import { ModalContent } from './ModalContent';

interface CreateTagPanelProps {
  onClose: () => void;
  updateSelectedTag: (tag: TagKnown) => void;
}

export const CreateTagPanel = (props: CreateTagPanelProps) => {
  const { onClose, updateSelectedTag } = props;
  const [tagName, setTagName] = useState<string>('');

  const [createTag, { data: createTagData, loading, error: createTagError }] =
    useCreateTagMutation();

  useEffect(() => {
    if (createTagData?.createTag?.tag) {
      updateSelectedTag(createTagData.createTag.tag as TagKnown);
    }
  }, [createTagData, updateSelectedTag]);

  const handleClose = () => {
    setTagName('');
    onClose();
  };

  const handleCreateTag = async () => {
    try {
      await createTag({
        variables: {
          input: {
            tagName: tagName.trim(),
          },
        },
      });
    } catch (error) {
      console.error('Failed to create tag: ', error);
    }
  };

  return (
    <ModalContent
      title={'Create a New Tag'}
      loading={loading}
      error={createTagError}
      handleClose={handleClose}
      submitDisabled={loading || !tagName}
      handleSubmit={handleCreateTag}
      buttonLabels={{ loading: 'Creating Tag...', create: 'Create' }}
    >
      <FormLabelContainer>
        <FormInput
          required
          placeholder="Enter a tag name"
          maxLength={120}
          aria-disabled={loading}
          defaultValue={tagName}
          autoCapitalize="none"
          onChange={(event): void => setTagName(event.target.value)}
        />
      </FormLabelContainer>
    </ModalContent>
  );
};
